<template>
  <div>
    <v-btn
      href="https://bdabce9b.sibforms.com/serve/MUIFAGwn_xJNa100NjYMXjD4CvFVAnIY2C9GMQUsC8KtUBz-uKn24Rc25rc0cCqmot41P6y24x0Eq7ls_9ejctPSKcB00-PqldtgXIVlv8LYMM1dblqrosN95zzC9Tj_dqE7ub3dC-43Qgktu9n1GCFAITQdEpHt1fkUnBZNPakSpqo78F9SyHERZ8pimWSu5ngpwZPBYUwaOoOC"
      target="_blank"
      color="secondary"
      elevation="2"
      >{{ $t("news.newsletter_subscription") }}</v-btn
    >
  </div>
</template>

<script>
import Vue from "vue";
export default Vue.component("subscribe-newsletter", {
  components: {},
  props: [],
  data: function() {
    return {};
  },
  mounted() {},
  methods: {}
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
